import SpiderCaution from '@assets/images/spider-caution.svg?react'
import SpiderError from '@assets/images/spider-error.svg?react'
import SpiderSuccess from '@assets/images/spider-success.svg?react'
import type React from 'react'

import css from './ImportSelectPages.module.scss'

type Props = {
  status: 'success' | 'failed' | 'warning'
}

const CrawlerStatusLogo: React.FC<Props> = ({ status }) => {
  return (
    <div className={css.image}>
      {status === 'warning' ? (
        <SpiderCaution />
      ) : status === 'failed' ? (
        <SpiderError />
      ) : (
        <SpiderSuccess />
      )}
    </div>
  )
}

export default CrawlerStatusLogo
